import React from "react";
import ProjectDetailCard from "../ProjectDetailCard";

import erp from "../../../Assets/Projects/website/ERP.png";
import erp2 from "../../../Assets/Projects/website/ERP2.png";
import erp3 from "../../../Assets/Projects/website/ERP3.png";
import erp4 from "../../../Assets/Projects/website/ERP4.png";

function ERPPos() {
  return (
    <ProjectDetailCard
      title="ERP Point of Sale System"
      image={erp}
      screenshots={[erp2, erp3, erp4]}
      description="
      ERP Point of Sale System is a web-based enterprise application designed to streamline retail business operations by integrating sales transactions, inventory management, customer records, and financial reporting into a centralized platform. The system enables cashiers to process transactions efficiently while providing administrators with real-time insights into product availability, sales performance, and business operations. Its responsive interface and comprehensive management features help improve operational efficiency, reduce manual processes, and support data-driven business decisions.
      "
      technologies={[
        "PHP",
        "CodeIgniter 4",
        "MySQL",
        "Bootstrap 5",
        "JavaScript",
        "HTML5",
        "CSS3",
        "ERP",
        "Point of Sale",
        "Git",
      ]}
      github="https://github.com/Rezaananda28"
      demo=""
    >
      <div className="project-section-card mt-4">
        <h3 className="purple">Project Gallery</h3>

        <div className="gallery-grid">
          {/* <img src={erp} alt="gallery1" />
          <img src={erp} alt="gallery2" />
          <img src={erp} alt="gallery3" /> */}
        </div>
      </div>
    </ProjectDetailCard>
  );
}

export default ERPPos;
